import * as React from 'react';

export const TermsContent: React.FC = () => (
  <div className='flex flex-col gap-6 text-left'>
    <div className='mb-4'>
      <h1 className='mb-2 font-sans text-24 font-bold leading-[32px] text-brand-800 md:text-32 md:leading-[40px]'>
        Terms And Conditions
      </h1>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>of DECHOES.COM</p>
    </div>

    <section>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        Welcome to DECHOES.COM application (the “Application” or the “App”), owned and operated by
        DECHOAI S.R.L., a limited liability company with registered offices in Voluntari, 1-8M
        Pipera boulevard, Block T4, Ground Floor, apartment B10, Ilfov county, Romania, registered
        in the Trade Register under no. J2025063859004, with unique registration number 52387032
        (the “Company”).
        <br />
        <br />
        Throughout these Terms and Conditions (the “T&C”), the terms “Decho AI”, “our”, “us”, and/or
        “we” refer to the Company. You may contact us with questions regarding your rights based on
        these T&C at support@dechoai.com
        <br />
        <br />
        These T&C govern your access to the Application and/or the website available at
        www.dechoes.com (the “Website”) and shall apply to all agreements concluded by the Company
        with you through the Application or the Website, including the underlying orders and
        declarations of acceptance by the Company, as well as any ancillary agreements.
        <br />
        <br />
        These T&C and any other terms of the Company incorporated by reference shall apply
        exclusively. Any of your terms and conditions that conflict with, deviate from or supplement
        the present T&C shall not apply unless the Company has expressly agreed to their application
        in writing. Notwithstanding article 1.202 para. 4 of the Romanian Civil Code (“RCC”), these
        T&C and, where needed, the provisions of the Romanian legislation are deemed to supersede
        and replace in full any other terms and conditions of the Customer.
        <br />
        <br />
        Individual agreements (including individual subscription agreements, supplements and
        amendments) concluded with the Customer and deviating information in the Company’s
        declarations of acceptance shall take precedence over the T&C.
        <br />
        <br />
        The Company may, without notice, at any time amend these T&C and any other information
        contained on the Website or in the Application at any time. The latest version of the T&C
        will be available in the Application and on the Website, and you should review the T&C prior
        to any use of the Application or the Website. Your continued use of the Application or
        Website will be considered acceptance of any version of T&C available during the time of
        use.
        <br />
        <br />
        The T&C also represent the prior information that we, as professionals, are required to
        provide to each consumer before concluding a distance contract, in accordance with the
        applicable provisions of Government Emergency Ordinance No. 34/2014 on consumer rights in
        contracts concluded with professionals, as well as for the amendment and supplementation of
        certain normative acts (“GEO No. 34/2014”).
      </p>
    </section>

    <section>
      <p className='font-sans text-16 font-bold leading-24 text-gray-600'>
        YOU ACKNOWLEDGE AND AGREE THAT BY CONFIRMING THESE T&C OR BY ACCESSING OR USING THE
        APPLICATION OR WEBSITE, WHICH CONSTITUTE DIGITAL CONTENT NOT SUPPLIED ON A TANGIBLE MEDIUM,
        YOU ARE PROVIDING PRIOR EXPRESS CONSENT FOR THE COMMENCEMENT OF THE PERFORMANCE OF THE
        CONTRACT DURING THE WITHDRAWAL PERIOD, WHICH IS 14 DAYS FROM THE DATE OF ACCEPTANCE OF THE
        T&C. AS SUCH, YOU ACKNOWLEDGE AND AGREE THAT YOU, AS THE CUSTOMER, WILL LOSE ANY STATUTORY
        RIGHT OF WITHDRAWAL FROM THE DISTANCE CONTRACT, IN ACCORDANCE WITH THE PROVISIONS OF GEO NO.
        34/2014.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 1 DEFINITIONS
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        All capitalized terms used herein shall have the meaning ascribed to them below:
        <br />
        <br />
        “Add-ons” means the optional features and functionalities that can be added to your
        subscription plan to enhance its capabilities, as they are shown in the Application or on
        the Website. These are available for an additional cost on top of your Subscription fee.
        <br />
        “Consumer” means any Customer who is a natural person and who enters into a legal
        transaction with the Company for a purpose that cannot be attributed to that person’s trade,
        business or profession.
        <br />
        “Customer” means any User who has access to the Application as per these T&C. The term
        Customer shall, unless otherwise specified, mean both Consumers and Businesses.
        <br />
        “Customer’s Data” means (i) data related to the Customer which is collected, used,
        processed, stored, or generated as the result of the use of the Application or Website; and,
        (ii) personally identifiable information collected, used, processed, stored, or generated as
        the result of the use of the Application or the Website, including, without limitation, any
        information that identifies an individual.
        <br />
        “Creator” means any User who creates, trains, configures, or publishes an Echo within the
        Application.
        <br />
        “Echo(es)” means a high-fidelity digital simulation of a natural person (whether a User or a
        public figure) generated by the Application, using artificial intelligence (“AI”) tools.
        Echoes are categorized as either “Personal Echoes” or “Public Echoes” as further described
        in Article 2 of these T&C.
        <br />
        “Subscription” means the recurring paid access granting the Customer specific usage rights
        to services provided via the Application.
        <br />
        “Problem” means a user-defined issue seeking resolution due to and limited to failure of the
        Application or Website to conform substantially to the specifications provided in these T&C.
        <br />
        “Resolution” means an explanation of probable reasons for the problematic performance of the
        Application or Website together with a recommended solution.
        <br />
        “User” means any visitor of the Application or Website. For clarity purposes, any reference
        to Users will include Customers and Creators, unless expressly excluded.
        <br />
        “User Content” means any data, including Customer’s Data, content, or materials uploaded,
        submitted, or otherwise transmitted by the User through the Application.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 2 DESCRIPTION OF THE APPLICATION
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        The Application is an artificial intelligence-based platform that enables the creation,
        customization, and interaction with digital avatars, named Echoes (the “Services”). The
        Application hosts two types of Echoes:
        <br />
        Personal Echo: a digital simulation of the User, intended to serve as the User’s own digital
        representative or personal avatar within the Application. Each User may create their own
        Personal Echo, using their own Customer’s Data, such as photos, videos, voice samples, or
        personal information. Users may, at their discretion, elect to make their Personal Echo
        available for interaction by other Users within the Application.
        <br />
        Public Echo: a digital simulation of the user as stated in 2.1.a available for interaction
        for any users on the platform.
        <br />
        <br />
        The Company reserves the right, at its sole discretion, to modify, update, limit, or
        discontinue the availability of any specific feature of the Echoes or any Personal or Public
        Echo (including the removal of a celebrity likeness if required by law or contractual terms)
        without prior notice.
        <br />
        <br />
        The Application provides simulated interactions where Echoes share general conversation,
        career-related reflections, personal development themes, educational content, and
        motivational content based on their specific AI programming. The User acknowledges that
        these outputs are strictly for personal inspiration and do not constitute professional
        consulting, financial planning, or career counselling. All real-world actions or decisions
        taken based on these simulations remain the User’s sole and exclusive responsibility. The
        User acknowledges and agrees that the Application is for entertainment, personal digital
        expression, and recreational purposes only.
        <br />
        <br />
        While Echoes may mimic the aspect, personality, knowledge, or expertise of the real persons
        they represent (e.g., a historical figure or an expert), the output generated by the
        Application:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>May contain inaccuracies;</li>
        <li>Is not professional advice of any kind;</li>
        <li>
          Does not constitute or create a legal relationship, agency, or representative bond between
          the User and the person (or estate of the person) the Echo represents. Specifically, no
          Echo, whether Public or Personal, is a legal substitute for a natural person. Outputs
          generated by an Echo are not legally binding on the Company, the User, or the individual
          the Echo emulates. No Echo has the authority to enter into contracts, provide professional
          certifications, or grant legal consent on any person’s behalf.
        </li>
      </ul>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 3 SERVICE ACCESS AND AVAILABILITY
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        The Company uses commercially reasonable efforts to ensure the Application and Website are
        available to Users on a continuous basis. However, the User acknowledges that the generation
        and usage of Echoes requires significant computational power, which may lead to limitations,
        delays, or downtime due to maintenance, updates, high traffic volume or other technical
        limitations.
        <br />
        <br />
        The Company reserves the right to amend, update, or modify the Application at any time to
        improve functionality, security, or compliance. We may make non-material changes (such as,
        but not limited to, bug fixes or layout updates) without prior notice. For changes that
        materially affect the core functionalities of your Subscription, we will provide notice via
        the Application or Website. If a material change is unacceptable to you, your sole remedy is
        to cease using the Application and cancel your Subscription. Your continued use following a
        modification constitutes your binding acceptance of the changes.
        <br />
        <br />
        The Application may include information from or links to third-party providers. The Company
        does not control these third parties and is not responsible for their services, accuracy, or
        compliance. Accessing these third-party sites is done at the User’s own risk. The User
        acknowledges and agrees that access to third-party sites via the Application does not imply
        any endorsement by the Company.
        <br />
        <br />
        The Application is provided on an “as is” and “as available” basis. The Company does not
        warrant that the Application will operate uninterrupted or error-free, nor that Echoes shall
        replicate faithfully the target personality.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 4 CONSUMER RIGHT OF WITHDRAWAL AND SUBSCRIPTION CANCELLATION
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        Consumers generally have a 14-day period to withdraw from a distance contract without
        justification.
        <br />
        The Application provides digital content not supplied on a tangible medium. By accessing or
        using the Application, you provide prior express consent for the performance of the contract
        to begin immediately. You acknowledge and agree that by providing this consent and accessing
        the digital content (the Echoes), you lose your statutory right of withdrawal from the
        contract once performance has begun.
        <br />
        Notwithstanding the loss of the statutory withdrawal right, Users may cancel their recurring
        Subscriptions at any time through the Application interface. Cancellation stops future
        renewals but does not entitle the User to a refund for the current billing period.
        <br />
        Customers may cancel their Subscription or delete their User account at any time via the
        account settings in the Application. Requests will be processed automatically, as further
        detailed in Section 13 of these T&C.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 5 ELIGIBILITY AND ACCESS
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        To access or use the Application, you must be at least eighteen (18) years old or have
        reached the age of majority in your jurisdiction and have the legal capacity to enter into
        binding agreements. If you are at least sixteen (16) years old, you may use the Application
        only with the express consent and supervision of a legal guardian.
        <br />
        <br />
        You represent and warrant that you are not located in, or a resident of, any jurisdiction
        subject to trade sanctions or where the use of the Application is prohibited by law.
        <br />
        <br />
        Access is prohibited if you have been convicted of crimes involving fraud, identity theft,
        or unauthorized access to computer systems. You must not have had a prior account suspended
        or terminated for a breach of these T&C.
        <br />
        <br />
        You shall provide and maintain complete, accurate, and up-to-date information for account
        registration and Application access. You must promptly update any information that becomes
        inaccurate.
        <br />
        <br />
        Use of the Application is strictly personal. You shall not assign, transfer, or otherwise
        convey any rights under these T&C to any third party without the prior written consent of
        the Company. You may not resell access or use Echoes for commercial advertising without a
        separate agreement.
        <br />
        <br />
        You are strictly responsible for maintaining the confidentiality of your credentials. You
        are prohibited from sharing, reselling, or distributing your access credentials. Any
        activity under your account is deemed yours unless you proved a breach beyond your control.
        <br />
        <br />
        You are prohibited from using the Application to collect, process, or otherwise handle
        personal data in a manner inconsistent with data protection laws, privacy principles, or the
        Application’s intended purpose.
        <br />
        <br />
        You must use reasonable security precautions, in line with latest security practices, in
        connection with your use of the Application.
        <br />
        <br />
        You acknowledge and agree that we may engage third-party service providers (e.g., Stripe for
        identity verification) and subcontractors to support the provision of the Application. The
        use of such third parties is essential for delivering a secure and reliable service.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 6 ACCEPTABLE USE POLICY (AUP)
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        You must provide complete and accurate information during registration and ID verification
        via Stripe.
        <br />
        <br />
        You are solely responsible for all data, prompts, instructions, and other content provided
        to the Application, and for all outputs you choose to store, share, or publish. You must
        ensure your use of the Application is lawful and complies with these T&C.
        <br />
        <br />
        You shall not use the Application to create, store, or disseminate content that is illegal
        or facilitates harmful activities, including but not limited to (a) terrorism, violent
        extremism, or incitement to violence, (b) child sexual abuse material or illegal hate
        speech, (c) harassment, stalking, or threats against individuals; (d) distribution of
        malware or deceptive practices such as scams or phishing.
        <br />
        <br />
        You shall not use any Echo in a misleading or deceptive way. Specifically:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>
          Until expressly permitted by the Company in writing, you are prohibited from creating a
          Personal Echo of any deceased individual;
        </li>
        <li>
          You shall not create an Echo of any living or deceased individual other than yourself,
          unless you have verified legal consent from the individual or their estate;
        </li>
        <li>
          You are prohibited from using a Personal Echo to impersonate a real person or to mislead
          others into believing they are interacting with an actual human;
        </li>
        <li>
          You are prohibited from attempting to pass off an Echo’s output as the actual speech,
          writing or appearance of the natural person it emulates;
        </li>
        <li>
          If you use the Application to create or share content that significantly resembles
          existing persons, objects, or events and would falsely appear to a person to be authentic
          (“Deepfakes”), you must clearly and visibly disclose that the content has been
          artificially generated or manipulated;
        </li>
        <li>
          Where required by law (including the EU AI Act), you must not remove, circumvent or
          obscure any “AI-generated” labels, watermarks or metadata embedded by the Company in the
          Application or Echo outputs.
        </li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        You shall not use the Application or Website in any manner that infringes upon the
        copyright, trademark, trade secret, image rights or right of publicity of any third party.
        <br />
        <br />
        You warrant that you have all necessary rights and authorizations to use the User Content
        uploaded to the Application. You shall not upload photos, voice samples, audio files, or
        data of any third party (including celebrities) without their express, verifiable and
        written consent.
        <br />
        <br />
        You acknowledge that Echoes are for inspirational, entertainment and recreational purposes
        only. You shall not use the Application to generate professional advice or for high-stakes
        decision-making. You shall not use the Application to facilitate fully automated
        decision-making that adversely impacts a person’s legal rights or creates a binding,
        enforceable legal obligation.
        <br />
        <br />
        You shall not engage in or use any data mining, robots, scraping, or similar automated data
        gathering or extraction methods in connection with the Application or Website.
        <br />
        <br />
        While the Application automatically applies AI-disclosure labels and watermarks on Echo
        outputs, the Users and Creators are strictly prohibited from:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>
          Removing or obscuring any watermarks or “AI-generated” labels when sharing Echo content on
          social media.
        </li>
        <li>
          Publishing content in a way that implies the person, including human celebrity, depicted
          by an Echo actually said those words in real life, even if a watermark is present.
        </li>
        <li>
          If Creators use Personal Echo output to create a video that looks like a real-world event
          (e.g., a Deepfake of themselves at a fake press conference), the Creators must manually
          add a clear, visible text overlay stating: “Artificially Generated Content”.
        </li>
      </ul>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 7 RIGHTS PROTECTION AND LEGAL TAKEDOWNS
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        Users have the right to notify the Company of any content (e.g., an unauthorized Public Echo
        or defamatory output) they identify within the Application. Notifications must be precise
        enough to enable identification of the content.
        <br />
        <br />
        The Company reserves the right, at its sole discretion, to refuse, suspend, or remove
        content or access to protect Users, ensure compliance with the law, or maintain the
        integrity of the Application.
        <br />
        <br />
        If the Company restricts or removes User Content, it will inform the User of the reasons and
        the legal or contractual basis for the decision. Users may challenge such decisions by
        submitting a complaint to the Company’s e-mail address.
        <br />
        <br />
        If you are a public figure, a legal representative of a public figure, or an heir/successor
        to the estate of an individual whose likeness has been used to create a Public Echo without
        authorization, you may submit a Takedown Notice to the Company’s support address. To be
        effective, a Takedown Notice must include:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>
          A physical or electronic signature of the person authorized to act on behalf of the owner
          of the likeness;
        </li>
        <li>Identification of the specific Public Echo(s) at issue, including direct URLs;</li>
        <li>Sufficient evidence to verify the identity of the person claiming the likeness;</li>
        <li>
          A statement that the information in the notice is accurate and that the use of the
          likeness in the manner complained of is not authorized by the owner, its agent, or the
          law.
        </li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        Upon receipt of a valid and complete Takedown Notice, the Company will use commercially
        reasonable efforts to investigate and, where appropriate, disable or remove the infringing
        Public Echo. The Company reserves the right to maintain content that constitutes protected
        speech, parody, or news reporting, or where the likeness of the individual is used in a
        non-identifiable or transformative manner.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 8 PRICING AND INVOCING
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        Access to the Application is provided free of charge and does not require the creation of a
        User account.
        <br />
        <br />
        Access to the premium features of the Application, including the interaction with and
        generation of Echoes, is governed by a prepaid credit system (the “Wallet”). Users may
        charge their Wallet by purchasing credit packages through the Application or Website.
        <br />
        <br />
        The Company may grant the User, upon signing up to the Application, a limited number of
        complimentary credits to trial the Services. Once these complimentary credits are exhausted,
        continued access to the Application requires the purchase of credit packages.
        <br />
        <br />
        Credits are consumed in real-time based on the User’s activity (e.g., duration of
        interaction with the Echoes, complexity of generation, or use of Add-ons). The remaining
        balance in the Wallet will be displayed to the User via a visual interface within the
        Application. Once the Wallet is empty, access to paid features will be suspended until the
        Wallet is recharged.
        <br />
        <br />
        The Wallet is not a bank account or a payment instrument; it is a ledger used to track your
        credits, the internal currency of the Application.
        <br />
        <br />
        Credits are denominated in EUR. Any prices displayed in other currencies are for reference
        only, and the final transaction amount may vary based on exchange rates and fees applied by
        your payment provider. Any foreign exchange fees or conversion rates applied by your bank or
        payment provider are your sole responsibility.
        <br />
        <br />
        If a payment is unsuccessful or declined for any reason, access to the paid features may be
        temporarily suspended until the outstanding payment is successfully completed.
        <br />
        <br />
        We reserve the right to modify the pricing for Add-ons or credit packages at any time,
        provided that such changes will not affect any services already in progress. Continued use
        of the Application after the notice period of an announced price increase expires shall be
        deemed as express acceptance of the revised pricing.
        <br />
        <br />
        Unless otherwise specified or required by applicable consumer law, credits stored in your
        Wallet do not expire, provided that your User account remains active. In the event of User
        account termination, including for a breach of these T&C, any remaining credits shall be
        forfeited.
        <br />
        <br />
        The Company may introduce newly developed functionalities, features, or Echo types as
        “Add-ons” or separate paid Subscription tiers. Access to these new functionalities may
        require the payment of additional fees.
        <br />
        <br />
        All payments must be made in advance through the payment methods made available in the
        Application or on the Website. Payments are securely processed through the Company’s
        authorized third-party payment processor. By making a payment to the Company, you agree to
        the terms of service and privacy policy of the relevant payment processor, as made available
        in the payment interface.
        <br />
        <br />
        The Customer shall pay all amounts due to the Company under these T&C in full, without any
        deduction, set-off, counterclaim, or withholding of any kind, except as may be required by
        law. Under no circumstances shall the Customer have the right to withhold, offset, or deduct
        any amounts from payments due to the Company, whether based on alleged claims, disputes, or
        for any other reason.
        <br />
        <br />
        Except as otherwise expressly provided in these T&C, all fees and charges paid by the
        Customer are non-refundable. The Company is under no obligation to provide, and the Customer
        shall not be entitled to, any reimbursement, credit, or refund for any amounts paid for any
        reason, including for partially used Subscription periods or credits, service
        dissatisfaction beyond a stated guarantee period, or the Customer’s non-use of the
        Application.
        <br />
        <br />
        The Customer agrees to receive electronic invoices in accordance with applicable law.
        Invoices shall be issued and transmitted electronically by the Company or its authorized
        payment processor within a maximum of five (5) days from the time of payment. Any disputes
        regarding invoices must be submitted in writing through the dedicated customer support
        interface without undue delay.
        <br />
        <br />
        If any rights have been granted, assigned or transferred based on the T&C, their grant,
        assignment or transfer is always subject to the condition precedent that all amounts due to
        the Company have been paid in full, to the sole satisfaction of the Company.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 9 INDEMNIFICATIONS AND LIMITATION OF LIABILITY
      </h4>
      <h5 className='mb-2 font-sans text-16 font-bold leading-24 text-gray-600'>
        Company’s Indemnification and Liability
      </h5>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        You agree to indemnify, defend, and hold harmless the Company, its affiliates, officers,
        directors, employees, and agents from and against any and all claims, damages, losses,
        liabilities, costs, and expenses, including reasonable legal fees, arising out of or
        relating to:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>your use or misuse of the Website, the Application or the Echoes;</li>
        <li>your violation of the T&C or any other applicable document between the parties;</li>
        <li>your breach of any applicable law or regulation;</li>
        <li>
          any User Content you upload, including claims that your Personal Echo infringes on the
          rights of a third party; or
        </li>
        <li>any unauthorized use of your account credentials.</li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        Your obligation to indemnify the Company includes claims arising from any Echo outputs you
        share that impugn the reputation of third parties or constitute verifiably false information
        intended to harm others.
        <br />
        <br />
        You acknowledge that AI-generated interactions are, by their nature, unpredictable and may
        produce output that is inaccurate, offensive, or otherwise objectionable. You evaluate and
        bear all risks associated with the use of such content. Furthermore, if you distribute or
        share outside the Application outputs generated by Echoes, you are strictly required to
        clearly label such content as artificially generated.
        <br />
        <br />
        You acknowledge that the Application utilizes AI to generate Echoes. The Company does not
        warrant the accuracy, truthfulness, or appropriateness of any output generated by an Echo.
        The Company disclaims all liability for any loss or damage arising from your reliance on
        AI-generated output, which is provided for entertainment purposes only.
        <br />
        <br />
        To the maximum extent permitted by applicable law, the Company’s total aggregate liability
        to you for any and all claims, losses, or damages arising out of or in connection with the
        Application, whether in contract, tort (including negligence), statutory duty, or otherwise,
        shall not exceed the total fees paid by you to the Company during the twelve (12) months
        preceding the event giving rise to the claim.
        <br />
        <br />
        In no event shall the Company be liable for any indirect, incidental or consequential
        damages, including but not limited to loss of profits, loss of revenue, loss of data, loss
        of reputation, business interruption or loss of business opportunity, even if the Company
        has been advised of the possibility of such damages or such damages were reasonably
        foreseeable.
        <br />
        <br />
        The Company shall not be liable for any failure or delay in performance resulting from
        causes beyond its reasonable control, including but not limited to acts of God, war,
        terrorism, labour disputes, supply shortages, or failures of third-party service providers.
        <br />
        <br />
        Nothing in these T&C shall limit or exclude the Company’s liability for death or personal
        injury caused by its direct intent, fraud or fraudulent misrepresentation, or any other
        liability that cannot be limited or excluded under applicable law.
      </p>

      <h5 className='mb-2 mt-6 font-sans text-16 font-bold leading-24 text-gray-600'>
        Creator’s Indemnification and Liability
      </h5>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        The User expressly assumes all risks associated with their interaction with, use of, or
        reliance upon any Echo. The User hereby waives and releases each Creator from any and all
        liability for harm, loss, or damage (whether financial, physical, reputational, or
        emotional) allegedly caused by such interaction or reliance.
        <br />
        <br />
        The User agrees to indemnify, defend, and hold harmless each Creator from and against any
        and all third-party claims, demands, actions, damages, losses, liabilities, costs, and
        expenses (including reasonable legal fees and costs of litigation) arising out of or
        relating to:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>
          the User’s sharing, republishing, or redistribution of any content generated by an Echo
          outside the Application;
        </li>
        <li>
          any claim that the User’s specific prompts or interactions caused an Echo to generate
          content that infringes upon the rights of any third party, including but not limited to
          intellectual property, privacy, image or publicity rights; or
        </li>
        <li>the User’s breach of these T&C in connection with such Echo.</li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        The User expressly acknowledges and agrees that (i) Echoes are autonomous AI systems that
        generate responses dynamically based on probabilistic models, and as such their outputs are
        not authored, reviewed, approved, or controlled by the Creator; (ii) Creators do not
        endorse, verify, warrant, or assume responsibility for any statement, opinion,
        recommendation, or other content generated by their Echoes during interactions with other
        Users; (iii) the configuration, training parameters, personality settings, or initial
        prompts provided by a Creator do not constitute a guarantee or representation regarding the
        accuracy, legality, safety, appropriateness, or quality of any specific output; and (iv) the
        User bears sole and exclusive responsibility for evaluating, verifying, and assuming all
        risks associated with any content generated by an Echo, and for any actions the User takes
        based upon such content.
        <br />
        <br />
        Creators who make Echoes available in the Application do so as independent contributors and
        are not agents, employees, partners, or representatives of the Company or of any other User.
        Each Creator acts solely on their own behalf. The relationship between you and any Creator
        whose Echo you interact with is governed exclusively by these T&C, and no separate
        contractual, fiduciary, or advisory relationship is created.
        <br />
        <br />
        Notwithstanding any other provision of these T&C, to the fullest extent permitted by
        applicable law, the total aggregate liability of any Creator to you for any and all claims
        arising out of or related to your use of, or interaction with, such Creator’s Echo shall not
        exceed the amount paid by you for credits used for interaction with that specific Echo,
        regardless of the legal theory asserted (whether based on contract, tort, negligence, etc.),
        and regardless of whether the Creator has been advised of the possibility of such damages.
        <br />
        <br />
        To the fullest extent permitted by the applicable law, no Creator shall be liable to you or
        any third party for any indirect, incidental, consequential, punitive, exemplary, special,
        or statutory damages, arising from or related to your interaction with their Echo, even if
        such damages were foreseeable or the Creator has been advised of the possibility of such
        damages.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 10 INTELLECTUAL PROPERTY
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        User Content. You retain all rights, title, and interest in the User Content, including any
        data, text, or materials, you upload to the Application for the purpose of receiving
        Services. You grant the Company a non-exclusive, worldwide, irrevocable, royalty-free,
        perpetual license to use, process, host, and display User Content to the extent necessary to
        provide the Services and, with the User’s express consent, for promotional case studies.
        <br />
        <br />
        The Company is provided a limited, non-exclusive license to use Customer’s Data for the sole
        purpose of providing the Services. This includes the right to collect, process, and store
        data to generate the Echoes. The Company shall: (i) maintain strict confidentiality and use
        appropriate care to avoid unauthorized access; (ii) disclose this data only as necessary for
        the Application and in accordance with applicable law; (iii) not sell, rent, or distribute
        this data for its own purposes without prior written consent.
        <br />
        <br />
        Personal Echoes. Personal Echoes are the exclusive property of the respective Users. To the
        extent that the Personal Echo is generated by the Application’s algorithms or service
        providers, the Company and/or the service provider hereby irrevocably assigns and transfers
        to the User all worldwide rights, title, and interest in and to the Personal Echo,
        contingent upon the successful deduction of the required Credits from the User’s Wallet for
        the creation of the Personal Echo. The User grants the Company a license to host and process
        the Personal Echo solely to render the Services.
        <br />
        <br />
        Public Echoes. The User acknowledges that the Company does not claim ownership over the
        underlying likeness, name, or persona of the individual whose digital simulation represents
        a Public Echo. Ownership of these rights remains with the respective estates or is governed
        by public domain laws. While the User may interact with a Public Echo, the User does not
        acquire any ownership rights to the Public Echo itself. The User is strictly prohibited from
        using Public Echoes to create endorsements, advertisements, or any content that falsely
        implies a connection between the personality portrayed as an Echo and a third-party product
        or service.
        <br />
        <br />
        Interactive Sessions Content. Subject to Section 10.6 of these T&C, you, the User, shall own
        the specific logs, chats, and derivative text generated by the Application during your
        session with Echoes (“Output”).
        <br />
        <br />
        Company IP. All software, algorithms, interface designs, logos, and trademarks associated
        with the Application itself (collectively, “Company IP”) are the exclusive property of the
        Company or its licensors and are protected by applicable intellectual property rights,
        whether registered or unregistered. Users are granted a limited, non-transferable license to
        use the Company IP only to access and use the Services in accordance with these T&C.
        <br />
        <br />
        Subject to the Customer’s compliance with these T&C, the Company grants the Customer a
        limited, non-exclusive, non-transferable, non-sublicensable, revocable license to access and
        use the Application, including the Application Content, solely for the Customer’s personal
        and non-commercial purposes related to their entertainment and self-development, and
        strictly in accordance with all applicable laws and regulations. The Customer may not use,
        copy, modify, distribute, sell, lease, sublicense, reverse engineer, decompile, disassemble,
        or create derivative works from the Application or any Application Content.
        <br />
        <br />
        You may, from time to time, provide suggestions, comments, or other feedback regarding the
        Application, the Website or the Services (“Feedback”). By submitting Feedback, you agree
        that the Company shall own such Feedback. You hereby irrevocably assign to the Company all
        right, title, and interest in and to the Feedback. In the event assignment is not legally
        possible, you grant the Company a worldwide, perpetual, irrevocable, royalty-free exclusive
        license to use, modify, distribute and exploit the Feedback for any purpose without
        restriction or compensation.
        <br />
        <br />
        Nothing in these T&C shall be construed as transferring any ownership rights in the
        Application, the Website or in the Company IP to the User. All rights not expressly granted
        to the User under these T&C are reserved by the Company.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 11 CONFIDENTIALITY
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        The User acknowledges that the Application contains valuable trade secrets and confidential
        information of the Company, including but not limited to the specific AI model weights,
        prompts not visible to the user, system architecture, and non-public API documentation. The
        User agrees not to disclose such information to third parties or use it for any purpose
        other than personal use of the Application.
        <br />
        <br />
        The Company shall treat Customer’s Data and User Content as confidential. The Company shall
        not disclose this data to third parties except:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>
          To subcontractors and third-party service providers (like Stripe for ID or cloud hosting)
          who are bound by similar confidentiality duties;
        </li>
        <li>When required by law or court orders;</li>
        <li>With the User’s express consent for promotional purposes.</li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        Confidentiality obligations do not apply to information that is already public (e.g., the
        identity of a celebrity used for a Public Echo), information obtained from a third party
        without a breach of duty, or information the Company must disclose to comply with safety and
        moderation standards.
        <br />
        <br />
        This confidentiality obligation survives for 2 years after account termination, except for
        the obligation to maintain the confidentiality of trade secrets, which shall be protected
        for as long as they qualify as such under the Romanian Law No. 11/1991 on unfair
        competition.
        <br />
        <br />
        Upon account termination, the Company will delete your raw User Content within 30 days,
        unless required to be stored by law.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 12 SERVICE STANDARDS AND COMPANY OBLIGATIONS
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        The Company shall use commercially reasonable efforts to maintain the availability of the
        Application. We will perform scheduled maintenance and may perform emergency maintenance to
        address security threats. While we strive for a seamless experience, we do not warrant that
        the Application will be uninterrupted, error-free, or entirely secure
        <br />
        <br />
        The Company shall provide the Services with reasonable skill and care. However, the User
        acknowledges that AI outputs are probabilistic and the Company does not warrant that Echoes
        shall faithfully or accurately replicate a target personality in every interaction.
        <br />
        <br />
        The Company will implement security measures consistent with industry standards to protect
        Customer’s Data and prevent unauthorized access to the Application.
        <br />
        <br />
        The Company implements content filters to prevent Echoes from generating illegal or harmful
        content; however, the Company does not guarantee that all illegal or harmful content will be
        successfully intercepted.
        <br />
        <br />
        The Company will use commercially reasonable technical means to ensure that all outputs
        generated by an Echo are accompanied by disclosure labels or digital watermarks identifying
        the content as AI-generated. The Company is not liable for unauthorized removal of such
        labels by third parties or by the User.
        <br />
        <br />
        The Company reserves the right to monitor interactions solely for the purpose of ensuring
        compliance with the Acceptable Use Policy, preventing the generation of harmful content and
        fulfilling mandatory transparency and safety obligations under applicable AI regulations.
        This includes the maintenance of any technical logs required by the EU AI Act, which shall
        be stored and processed in accordance with our data retention policies
        <br />
        <br />
        The Company is not responsible for any unauthorized access to the Application or the
        unauthorized use of the Products unless the unauthorized access or use is a result of the
        Company’s failure to meet its obligations as provided for in these T&C.
        <br />
        <br />
        The Company may use information compiled and/or prepared by or from third parties in the
        Application. The Company undertakes to make its best efforts to obtain such information from
        reliable sources where possible, but the User agrees that such information used by Company
        shall be provided “as is” and the Company bears no liability for its reliability,
        completeness or accuracy.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 13 SUSPENSION AND TERMINATION
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        These T&C remain in effect from your first access until your account is terminated.
        <br />
        <br />
        Subscription termination. You may cancel a recurring Subscription at any time via the
        Application interface to stop future billing. No refunds will be issued for any prepaid fees
        upon such termination.
        <br />
        <br />
        Account deletion. The User may initiate the deletion of their account at any time through
        the Application interface. To prevent accidental deletion, this action requires express
        confirmation from the User.
        <br />
        <br />
        Upon the User’s confirmation of account deletion:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>The account will be immediately deactivated and become inaccessible to the User;</li>
        <li>Any active Subscription will cease starting with the next billing period;</li>
        <li>
          A 30-day grace period will commence, during which the account data is stored to allow for
          potential reactivation.
        </li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        If the User does not reactivate the account within this 30-day period, the account will be
        permanently removed. This results in the irreversible loss of all data, including but not
        limited to digital echoes, conversation history, analytics, and personal preferences. The
        User acknowledges that once the 30-day period expires, the data cannot be recovered.
        <br />
        <br />
        In the case of a Creator’s death, the authorized heirs or the estate shall have the right to
        exercise the deletion of the Creator’s account, resulting in the permanent erasure of the
        Echo and its data within 30 days.
        <br />
        <br />
        Suspension by the Company. The Company, in its sole discretion, may suspend the access to
        the Application in case:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>
          the Company reasonably believes that the Application is being used in breach of the T&C or
          the applicable law;
        </li>
        <li>
          the Customer does not cooperate with Company’s reasonable investigation of any suspected
          violation of the T&C;
        </li>
        <li>
          there is an external attack on the Application or aimed at the Application or the
          Application is being accessed or manipulated by a third party without the Customer’s
          consent;
        </li>
        <li>of a specific request or order from a public authority or government body;</li>
        <li>of non-payment or overdue payment of any applicable fees;</li>
        <li>of a period of at least 12 months of inactivity;</li>
        <li>
          any other events occur and the Company reasonably believes that the suspension of the
          Application is necessary to protect the Company or its business, the performance of the
          Application, the system’s infrastructure or third parties’ rights.
        </li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        Should any of the above events occur, the Company shall notify in writing the Customer
        regarding the suspension of access and the reason for such action.
        <br />
        <br />
        Termination by the Company. The Company reserves the right to terminate your access to the
        Application, in whole or in part, at any time and for any reason (with or without cause)
        upon written notice. Such reasons for termination include, but are not limited to, the
        circumstances for suspension set forth in Section 13.6. You agree that any termination of
        your access may be effected without prior notice in the Company’s sole discretion, and that
        the Company shall not be liable to you or any third party for any such termination.
        <br />
        <br />
        Where possible, the Company will provide you with prior notice of termination and an
        opportunity to remedy any breach, except where immediate action is deemed necessary to
        protect the Application, the Company, or other Users.
        <br />
        <br />
        Upon termination of your access to the Application for any reason:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>all rights and licenses granted to you under these T&C will immediately cease;</li>
        <li>your access to the Application will be discontinued;</li>
        <li>
          any outstanding fees or charges incurred prior to the effective date of termination become
          immediately due and payable;
        </li>
        <li>
          the Company may but is not obligated to provide the Customer with a limited period not
          exceeding thirty (30) days to access, export, or retrieve the Customer’s Data, after which
          all data shall be permanently deleted, except as otherwise required by law.
        </li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        Any provisions of the T&C that by their nature should survive termination, including but not
        limited to those relating to intellectual property, confidentiality, indemnification,
        limitation of liability, and payment obligations, shall survive the termination of the
        User’s access to the Application.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 14 FORCE MAJEURE
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        A Force Majeure event is defined in accordance with the provisions of the Romanian Civil
        Code and it includes acts of God, war, and terrorism, but also includes:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>major, widespread failures of the internet or power grid;</li>
        <li>large-scale cyber-attacks that exceed industry-standard defenses;</li>
        <li>
          critical failure of third-party AI infrastructure (e.g., cloud computing/GPU providers)
          that is beyond the Company’s control;
        </li>
        <li>
          sudden changes in mandatory law or regulatory “kill-switches” under the EU AI Act that
          force the immediate suspension of certain AI models.
        </li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        A party whose activity in performing the obligations hereunder is impeded due to a force
        majeure event may suspend the performance of its obligations during the period of time while
        the force majeure event lasts. A force majeure event shall not relieve the parties from the
        obligation to use their best efforts to mitigate the damages caused by the failure to
        perform or default performance due to the force majeure event.
        <br />
        <br />
        The affected party shall notify the other party within a maximum period of seventy-two (72)
        hours from the occurrence of the force majeure event, detailing its nature, estimated
        duration, and impact. In case of a force majeure event lasting for more than 60 days,
        parties may terminate the agreement, by written notice submitted to the other party, without
        any formality or court intervention and without any further payment of damages. For the
        avoidance of doubt, any outstanding debts shall be promptly paid by the parties.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 15 GOVERNING LAW AND JURISDICTION
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        These T&C, as well as any use of the Application or Website, are governed by the laws of
        Romania.
        <br />
        <br />
        In the event of any dispute arising out of or in connection with these T&C, the parties
        shall attempt, in good faith, to resolve the dispute amicably. If an amicable settlement
        cannot be reached within thirty (30) calendar days from the date one party notifies the
        other of the dispute, the dispute shall be submitted to the competent courts of Bucharest,
        Romania.
        <br />
        <br />
        By accepting these T&C, you agree that any matters relating to the validity, interpretation,
        performance, or termination of these T&C, or any dispute arising out of or in connection
        with them, including non-contractual obligations, shall be subject to the exclusive
        jurisdiction of the competent courts of Bucharest, Romania, and if the materially competent
        court is a courthouse, the parties agree that the competent court shall be the 5th District
        Courthouse of Bucharest, Romania.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        Article 16 MISCELLANEOUS
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        The Company may assign its rights and obligations to a successor in the event of a merger or
        acquisition. The User may not assign their account without the Company’s prior written
        consent, such consent not to be unreasonably withheld or delayed.
        <br />
        <br />
        No single or partial exercise of any right or remedy under these T&C shall constitute a
        waiver of that or any other right or remedy. A waiver of any breach of any provision shall
        not be deemed a waiver of any subsequent breach.
        <br />
        <br />
        The invalidity or unenforceability of any provision or part of a provision of these T&C
        shall not affect the validity or enforceability of the remaining provisions. The parties
        agree to replace any invalid or unenforceable provision with a valid and enforceable
        provision that most closely reflects the original intent and economic effect of the invalid
        provision.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        CONTACT US
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        If you have any questions about our Services, or to report any violations of these T&C,
        please contact us at [support@dechoai.com]
        <br />
        Last update of T&C on: 25.01.2026
      </p>
    </section>
  </div>
);
